import { render, staticRenderFns } from "./ToDoListMobileCard.vue?vue&type=template&id=6a5a963b&scoped=true"
import script from "./ToDoListMobileCard.vue?vue&type=script&lang=js"
export * from "./ToDoListMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a963b",
  null
  
)

export default component.exports